import type { ColumnDef } from '@tanstack/react-table';
import type {
  ScheduledViagensBillingReport as Report
} from 'contracts/scheduled-reports';
import { ScheduledReportsDataTableHelper, Formatter } from 'utils';

const dt = new ScheduledReportsDataTableHelper<Report>();

type HookOptions = {
  onClickDownload?: (reportId: number) => void
}

export const useViagensBillingReportColumns = ({ onClickDownload }: HookOptions): ColumnDef<Report>[] => {
  const createdAt = dt.buildColumn({
    id: 'Requisitado em',
    accessorKey: 'created_at',
    content: (row) => Formatter.date(row.created_at),
  });
  const finishedAt = dt.buildColumn({
    id: 'Finalizado em',
    accessorKey: 'finished_at',
    content: (row) => Formatter.date(row.finished_at),
  });
  const statusAndDownload = dt.buildReportStatusColumn({
    id: 'Status',
    title: '',
    onDownloadButtonClick: onClickDownload,
  });

  return [
    createdAt,
    finishedAt,
    statusAndDownload,
  ];
};
